import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import { WB_ProductHierarchyRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import { esWB_Product_Hierarchy} from "../PA.Core/PAdbSchema";
import {ProductHierarchyBO} from "./ProductHierarchyBO";


export class ProductHierarchyBOValidations {


    static async ValidateFields(aBO: ProductHierarchyBO): Promise<void> {

        let dbContext = new PAdbContext({})


        // Validate Product Hierarchy Name
        if (_.isEmpty(aBO.WB_ProductHierarchy.cif.WB_PRD_HIER_NAME)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyName',
                    type: MessageType.Error,
                    title: "Product Hierarchy Name cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage('EmptyName')
        }

        if (_.isEmpty(aBO.WB_ProductHierarchy.cif.WB_PRD_HIER_ID)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyID',
                    type: MessageType.Error,
                    title: "Product Hierarchy ID cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage('EmptyID')
        }


        // Product Hierarchies are considered duplicates only within the same Master Data Set
        let prdHRows: WB_ProductHierarchyRow[] = await dbContext.findAll(esWB_Product_Hierarchy,
            {where: {DELETED_IND: {neq: '1'},
                    WB_PRDH_ID: {neq: aBO.WB_ProductHierarchy.cif.WB_PRDH_ID},
                    WB_MDSET_ID: aBO.WB_ProductHierarchy.cif.WB_MDSET_ID,
                    WB_PRD_HIER_ID: aBO.WB_ProductHierarchy.cif.WB_PRD_HIER_ID.trim()}})



        if (!_.isEmpty(prdHRows)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "duplicateID", type: MessageType.Error,
                title: 'Existing Product Hierarchy with the same ID: ' +
                    '\nProduct Hierarchy: ' + _.map(prdHRows, (a) => `${a.cif.WB_PRD_HIER_NAME} (${a.cif.WB_PRD_HIER_ID})`).join(","),
                description: "",
                subtitle: "",
                count: 0
            })
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }



    }
}
